import { lazy } from 'react';

import type { AppRouteConfig } from '@/App/AppRoutes/types';

const ForgotPasswordCompletePage = lazy(() =>
  import('@/components/pages/ForgotPasswordCompletePage').then(({ ForgotPasswordCompletePage }) => ({
    default: ForgotPasswordCompletePage,
  })),
);

export const ForgotPasswordCompleteRoute: AppRouteConfig = {
  key: 'forgot-password-complete-page',
  path: '/forgot_password_complete/:locale?',
  component: ForgotPasswordCompletePage,
};
